import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PaymentCard } from '../models/payment-card.model';

@Injectable({
  providedIn: 'root'
})
export class PaymentService extends ApiBaseService {

  tokenizeCard(cardData: {
    numero_tarjeta: string;
    nombre_titular: string;
    mes_expiracion: string;
    ano_expiracion: string;
    cvv: string;
    verification_code?: string;
  }): Observable<any> {
    return this.post('/comercio/payments/tokenize-card', cardData);
  }

  getCards(): Observable<PaymentCard[]> {
    return this.get<{ status: string; data: PaymentCard[] }>('/comercio/payments/cards').pipe(
      map(response => response.data ?? [])
    );
  }
}
